import { useRef, useState } from 'react';
import styled from '@emotion/styled';
import IcMoreHorizontalRegular from 'src/assets/images/icMoreHorizontalRegular.svg';
import { useDMEventLog } from 'src/hooks/useDMEventLog';
import RoomItemMoreModal from './RoomItemMoreModal';
import { DesktopMoreButton } from './styles';
const MoreIcon = styled(IcMoreHorizontalRegular)`
  width: 24px;
  height: 24px;
`;
interface Props {
  messageThreadId: string;
  onBlockAndLeave: () => void;
  onLeave: () => void;
  onOpenChange?: (isOpen: boolean) => void;
}
export default function RoomItemMoreMenu({
  messageThreadId,
  onBlockAndLeave,
  onLeave,
  onOpenChange
}: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const {
    logOpenSettings
  } = useDMEventLog();
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    logOpenSettings({
      messageThreadId,
      page: 'main'
    });
    setIsOpen(true);
    onOpenChange?.(true);
  };
  const handleClose = () => {
    setIsOpen(false);
    onOpenChange?.(false);
  };
  const buttonRect = buttonRef.current?.getBoundingClientRect();
  return <>
      <DesktopMoreButton ref={buttonRef} type='button' isOpen={isOpen} onClick={handleClick} data-sentry-element="DesktopMoreButton" data-sentry-source-file="RoomItemMoreMenu.tsx">
        <MoreIcon data-sentry-element="MoreIcon" data-sentry-source-file="RoomItemMoreMenu.tsx" />
      </DesktopMoreButton>
      {isOpen && <RoomItemMoreModal messageThreadId={messageThreadId} buttonRect={buttonRect} onClose={handleClose} onBlockAndLeave={onBlockAndLeave} onLeave={onLeave} />}
    </>;
}